module.exports = __webpack_public_path__ + "8e3dc3f11bfff3ca69cd225d6ef075bf.fbx";